__webpack_require__.p = "https://statics-americanas.b2w.io/catalog-statics/acom/";